import { TokenInfo } from "@/stores/useTokenStore";

export const updateTokens = (
  setTokenInfo: (tokenInfo: TokenInfo | null) => void,
  response: any
) => {
  setTokenInfo({
    token: response.data.token,
    refreshToken: response.data.refreshToken
  });
};
